import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { HEIGHT_ONE_PERCENT } from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterGantDraggable } from '../store/slices/gantDraggableSlice';
import { DraggableGantType, ItemType } from '../types';

interface IGantItemMarker {
    item: ItemType;
    x: number;
    draggingType?: DraggableGantType;
}

const GantItemMarkerBond: React.FC<IGantItemMarker> = ({ item, x, draggingType }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const currentDropBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDropBond);
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);

    const handleMouseDown = () => {
        console.log('>>>>>>>>>>>', draggingType);
        if (!currentDropBond && !currentDragBond) {
            dispatch(
                setterGantDraggable({
                    dragging: draggingType,
                    currentDragBond: item,
                }),
            );
        }
    };

    const commonProps: React.SVGProps<SVGRectElement> = {
        onMouseDown: handleMouseDown,
        cursor: 'grab',
    };

    const side = (HEIGHT_ONE_PERCENT * 60) / Math.sqrt(2) / 2;
    const cx = x + (draggingType === 'bondLeft' ? -HEIGHT_ONE_PERCENT * 60 : 0) + (HEIGHT_ONE_PERCENT * 60) / 2;
    const cy = HEIGHT_ONE_PERCENT * 20 + (HEIGHT_ONE_PERCENT * 60) / 2;

    return (
        <g>
            <rect
                x={x + (draggingType === 'bondLeft' ? -HEIGHT_ONE_PERCENT * 70 : HEIGHT_ONE_PERCENT * 10)}
                fill={'red'}
                y={HEIGHT_ONE_PERCENT * 20}
                width={HEIGHT_ONE_PERCENT * 60}
                height={HEIGHT_ONE_PERCENT * 60}
                strokeWidth={1}
                stroke={'#bbb'}
                opacity={0.001}
                {...commonProps}
            />
            <rect
                x={cx - side / 2}
                y={cy - side / 2}
                width={side}
                height={side}
                fill={'#5ced34'}
                transform={`rotate(45, ${cx}, ${cy})`}
                strokeWidth={1}
                stroke={'#5c5c5c'}
                opacity={1}
                {...commonProps}
            />
        </g>
    );
};

export default React.memo(GantItemMarkerBond);
